import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { generateUUID } from '../utils';

export class TraceRequestInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const traceRequestId = req.clone({
      headers: req.headers.set('x-trace-request-id', generateUUID())
    });

    return next.handle(traceRequestId);
  }
}
